import { Box, BoxProps } from "@mui/material";
import { FC } from "react";
import { TWeightVariant } from "../../types";

export type THypeIcon = {
  name: HypeIconName;
  size?: number;
  color?: THypeColors;
  weight?: TWeightVariant;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
} & Partial<BoxProps>;

/**
 * @desc Render an Icon
 *
 * @param name icon name
 * @param size (optional default 20px) size of icon
 * @param color (optional default "primary.main") color of icon
 *
 * @example Simple Dialog
 * <HypeIcon name="icon-crono" color="peru" size={40} />
 *
 */

export const HypeIcon: FC<THypeIcon> = ({
  name,
  size = 18,
  color = "inherit",
  weight = 400,
  onClick,
  ...rest
}) => {
  const { sx, ...remainingProps } = rest;
  return (
    <Box
      className={`icon-${name}`}
      role="img"
      aria-label={name}
      sx={{
        fontSize: `${size}px`,
        fontWeight: weight,
        color,
        cursor: onClick && "pointer",
        ...sx,
      }}
      onClick={onClick}
      {...remainingProps}
    />
  );
};
